import type {
  IOrderStatus,
  IUpdateOrderStatusRequest,
} from '../../services/workService';

export interface OrderStatusFormValues {
  color: string;
  icon: string;
}

export const toOrderStatusFormValues = (
  status: IOrderStatus
): OrderStatusFormValues => ({
  color: status.color ?? '',
  icon: status.icon ?? '',
});

export const orderStatusBody = (
  status: IOrderStatus,
  values: OrderStatusFormValues
): IUpdateOrderStatusRequest => ({
  name: status.name,
  code: status.code,
  color: values.color,
  icon: values.icon,
  isCompleted: status.isCompleted ?? status.IsCompleted,
  lockEntity: status.lockEntity ?? status.LockEntity,
  clientLabel: status.clientLabel,
  managerLabel: status.managerLabel,
  contractorLabel: status.contractorLabel,
  clientStatusGroupId: status.clientStatusGroupId,
  managerStatusGroupId: status.managerStatusGroupId,
  contractorStatusGroupId: status.contractorStatusGroupId,
  permissions: status.permissions,
});
